import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { Form, Text, Select } from 'react-form';
import { api,confirm } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { Switch } from "@src/services/form";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoList, PropsList, StateList, FixUrl } from '@src/components/Proto';
import { SettingsUser as Edit, Box } from '@src/components';
import { isReadOnly, user, isThisUser, customer } from 'services/user';

// typing
interface LocalProps extends PropsList {
    
}
interface LocalState extends StateList {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class User extends ProtoList<LocalProps, LocalState> {
    
    DeleteBtn = () => {
        return row => {
            if (isThisUser(row.original.email)|| customer().email==row.original.email) return null;
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.deleteItem(row);
                        } }
                    >
                        {_('col_customer_delete', 'SettingsUser')}
                    </button>
                </div>
            );
        }
    };
    async deleteItem( row ) {
        try {
            await confirm(_('col_customer_delete_confirm', 'SettingsUser'));
        } catch(e) {
            return;
        }
        const { urlDelete = "" } = this.props;
        const url = urlDelete;
        const method = "DELETE";
        try {
            const res = await api({
                url: FixUrl(url, row.original.userid),
                method
            });
            this.reload()
        } catch(e) {
        }
    }
	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { cpt, urlShow, urlCreate, urlUpdate } = this.props;
        const { loading, action, editing, data, search = {}, items = [], tableProps, editProps } = this.state;
        
        const columns = [
            { ...defaultProps.columns.id, accessor: 'userid' },
            { Header: _('col_fullname', 'SettingsUser'), accessor: 'fullname' },
            { Header: _('col_email', 'SettingsUser'), accessor: 'email' },
            { Header: _('col_customer', 'SettingsUser'), accessor: 'customer' },
            {Header: '',
            accessor: 'delete',
            maxWidth: 100,
            Cell: !isReadOnly()?this.DeleteBtn():null,
            sortable: false,}
            //{ ...this.SwitchColumn }
        ];
        
        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
            }
        }
        localTableProps.loading = loading;
        
        let localEditProps = {
            ...editProps
        } as any;
        if (action === "EDIT" && !isReadOnly() ) {
            localEditProps.id = editing;
        }

		return (
            <>
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            <Box
                title={_('list_title', 'SettingsUser')}
                toolbar={!isReadOnly()?this.Toolbar:null}
                collapsed={false}
            >
            </Box>
            
            <ReactTable
                {...localTableProps}
                data={items}
                columns={columns}
            />

            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/List/User.tsx